import client from './client';
import { Company, CompanyCreate, CompanyUpdate, CompanyListItem } from '../types/company';

export interface SearchCompaniesResult {
  results: CompanyListItem[];
  count: number;
  query: string;
}

export const searchCompanies = async (query: string, limit: number = 20): Promise<SearchCompaniesResult> => {
  const response = await client.get('/api/v1/companies/search', {
    params: { q: query, limit },
  });
  return response.data;
};

export const getCompany = async (id: string): Promise<Company> => {
  const response = await client.get(`/api/v1/companies/${id}`);
  return response.data;
};

export const createCompany = async (data: CompanyCreate): Promise<Company> => {
  const response = await client.post('/api/v1/companies/', data);
  return response.data;
};

export const updateCompany = async (id: string, data: CompanyUpdate): Promise<Company> => {
  const response = await client.put(`/api/v1/companies/${id}`, data);
  return response.data;
};

export const deleteCompany = async (id: string): Promise<void> => {
  await client.delete(`/api/v1/companies/${id}`);
};

export const addTechnologyToCompany = async (companyId: string, technologyId: string): Promise<void> => {
  await client.post(`/api/v1/companies/${companyId}/technologies/${technologyId}`);
};

export const removeTechnologyFromCompany = async (companyId: string, technologyId: string): Promise<void> => {
  await client.delete(`/api/v1/companies/${companyId}/technologies/${technologyId}`);
};

export const getCompanyPipeline = async (companyId: string): Promise<any[]> => {
  const response = await client.get(`/api/v1/companies/${companyId}/pipeline`);
  return response.data;
};

export const addTherapeuticToCompany = async (
  companyId: string,
  therapeuticName: string,
  developmentStageName: string,
  indicationName: string
): Promise<any> => {
  const response = await client.post(`/api/v1/companies/${companyId}/therapeutics`, {
    therapeutic_name: therapeuticName,
    development_stage_name: developmentStageName,
    indication_name: indicationName,
  });
  return response.data;
};

export const updateDrugDevelopment = async (
  companyId: string,
  drugDevelopmentId: string,
  developmentStageName?: string,
  indicationName?: string
): Promise<any> => {
  const response = await client.put(
    `/api/v1/companies/${companyId}/drug-developments/${drugDevelopmentId}`,
    {
      development_stage_name: developmentStageName,
      indication_name: indicationName,
    }
  );
  return response.data;
};

export const removeTherapeuticFromCompany = async (
  companyId: string,
  therapeuticId: string
): Promise<void> => {
  await client.delete(`/api/v1/companies/${companyId}/therapeutics/${therapeuticId}`);
};

export const enrichCompany = async (
  id: string
): Promise<{ proposed_changes: Record<string, any>; missing_fields: string[]; present_fields: string[]; error?: string }> => {
  const response = await client.post(`/api/v1/companies/${id}/enrich`, {}, { timeout: 1800000 });
  return response.data;
};

export const batchEnrichCompanies = async (data: { company_ids: string[] }): Promise<any> => {
  const response = await client.post('/api/v1/companies/batch-enrich', data, { timeout: 1800000 });
  return response.data;
};
